import React from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {Card, Col, Row} from "antd";
import {URLS} from "@/lib/urls";
import {useApiReadAdminDashboard} from "@/api/dashboard";
import {Link} from "react-router-dom";
import RenderIf from "@/components/render-if";
import TextToHtml from "@/components/text-to-html";
import AdminWelcomeSection from "@/pages/admin/dashboard/_section/AdminWelcomeSectino";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";


const navCards = [
    {
        title: 'اعضا',
        icon: <span className={'icon-users1 text-blue-700 text-3xl'}/>,
        link: URLS.admin.members.list,
        can: PermList.MEMBER_LIST
    },
    {
        title: 'نظرسنجی‌ها',
        icon: <span className={'icon-poll-people text-blue-700 text-3xl'}/>,
        link: URLS.admin.survey.dashboard,
        can: PermList.SURVEY_LIST
    },
    {
        title: 'کد تخفیف',
        icon: <span className={'icon-gift text-blue-700 text-3xl'}/>,
        link: URLS.admin.discount.list,
        can: PermList.DISCOUNT_LIST
    },
    {
        title: 'محل‌های برگزاری کلاس',
        icon: <span className={'icon-location text-blue-700 text-3xl'}/>,
        link: URLS.admin.classroom.dashboard,
        can: PermList.CLASSROOM_LIST
    },

    {
        title: 'درخواست بازگشت وجه',
        icon: <span className={'icon-money-bill text-blue-700 text-3xl'}/>,
        link: URLS.admin.refund.dashboard,
        can: PermList.REFUND_LIST
    },

    {
        title: 'سرفصل‌ها',
        icon: <span className={'icon-book text-blue-700 text-3xl'}/>,
        link: URLS.admin.topic.dashboard,
        can: PermList.TOPIC_LIST
    },

    {
        title: 'سامانه تحویل اقلام',
        icon: <span className={'icon-tag text-blue-700 text-3xl'}/>,
        link: URLS.admin.products.dashboard,
        can: PermList.PRODUCT_DASHBOARD
    },


];


function AdminDashboardPage() {

    const {data: dashboard, isPending: isPendingDashboard} = useApiReadAdminDashboard()

    return (
        <AdminLayout pageTitle={'داشبورد مدیریت'}>

            <AdminWelcomeSection/>

            <div>

                <div className="flex flex-wrap mb-4">
                    {navCards.map((card, index) => (
                        <Can permission={card?.can} key={index + 'admin-dashboard-menu'}>
                            <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-3 mb-6">
                                <Link to={card.link} className="block h-full">
                                    <Card
                                        hoverable
                                        className="h-full text-center rounded-2xl bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700"
                                    >
                                        {card.icon}
                                        <div className="mt-2 font-bold text-lg text-gray-800 dark:text-gray-100">
                                            {card.title}
                                        </div>
                                    </Card>
                                </Link>
                            </div>
                        </Can>
                    ))}
                </div>
                <RenderIf condition={dashboard?.data?.data?.billboard}>
                    <Card title="تابلو اعلانات" className={'rounded-2xl'}>
                        <TextToHtml>{dashboard?.data?.data?.billboard}</TextToHtml>
                    </Card>
                </RenderIf>
            </div>
        </AdminLayout>
    );
}


export default AdminDashboardPage;
